import AxiosConfig from '@/config/axios-config'

export const QuestaoAPI = {

  listar (pagina, filtro) {
    return AxiosConfig.jalekoAPI().get('/admin/conteudo/questoes',
      {
        params: {
          page: pagina,
          tipo_questao_id: filtro.tipo,
          questao: filtro.nome,
          ano: filtro.ano,
          professor: filtro.professor,
          enunciado: filtro.enunciado,
          resposta1: filtro.resposta1,
          comentario: filtro.comentario,
          curso: filtro.curso,
          modulo: filtro.modulo,
          licao: filtro.licao
        }
      }).then(response => response.data)
  },

  importarQuestoes (arquivo) {
    let formData = new FormData()
    formData.append('file', arquivo)

    return AxiosConfig.secureJalekoAPI().post('/admin/conteudo/questao/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  },

  obterStatusImportacaoQuestoes () {
    return AxiosConfig.secureJalekoAPI().get('/admin/conteudo/questao/upload/status').then(response => response.data)
  },

  salvar (questao) {
    let formData = new FormData()
    questao.imagensEnunciado.map(imagem => {
      formData.append('imagensEnunciado[]', imagem)
    })
    questao.imagensComentario.map(imagem => {
      formData.append('imagensComentario[]', imagem)
    })
    for (var key in questao) {
      formData.append(key, questao[key])
    }
    return AxiosConfig.secureJalekoAPI().post('/admin/conteudo/questao', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  },

  editar (questao) {
    let formData = new FormData()
    questao.imagensEnunciado.map(imagem => {
      formData.append('imagensEnunciado[]', imagem)
    })
    questao.imagensComentario.map(imagem => {
      formData.append('imagensComentario[]', imagem)
    })
    for (var key in questao) {
      questao[key] &&
      formData.append(key, questao[key])
    }
    return AxiosConfig.secureJalekoAPI().post(`/admin/conteudo/questao/${questao.id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  },

  listarModalidades () {
    return AxiosConfig.secureJalekoAPI().get('/admin/modalidades').then(response => response.data)
  },

  listarFontes () {
    return AxiosConfig.secureJalekoAPI().get('/admin/fontes').then(response => response.data)
  },

  listarPublicos () {
    return AxiosConfig.secureJalekoAPI().get('/admin/publicos').then(response => response.data)
  },

  listarCursos () {
    return AxiosConfig.secureJalekoAPI().get('/cursos').then(response => response.data)
  },

  listarModulos () {
    return AxiosConfig.secureJalekoAPI().get('/modulos').then(response => response.data)
  },

  listarLicoes () {
    return AxiosConfig.secureJalekoAPI().get('/licoes').then(response => response.data)
  }

}

export default QuestaoAPI
